jQuery(function($){
  $('.loadmorewrap .button').click(function(){

    var button = $(this),
      container = $('.addposts'),
      data = {
        'action': 'loadmore',
        'query': loadmore_params.posts, // that's how we get params from wp_localize_script() function
        'page' : loadmore_params.current_page,
        'max_page' : loadmore_params.max_page
      };

    $.ajax({
      url : loadmore_params.ajaxurl, // AJAX handler
      data : data,
      type : 'POST',
      beforeSend : function ( xhr ) {

        button.text('Ladataan...');

         // change the button text, you can also add a preloader image
      },
      success : function( data ){
        if( data ) {

          button.html('Lataa lisää<span></span>');

          container.before(data); // insert new posts

          loadmore_params.current_page++;

          if ( loadmore_params.current_page == loadmore_params.max_page ) {
            button.remove(); // if last page, remove the button
          }

        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });
});
